import * as React from 'react';

const IdealPaymentRebrandingSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 192 128" fill="none" {...props}>
        <g clipPath="url(#ideal-payment-rebranding_svg__clip0_101_983)">
            <path
                d="M0 16C0 7.163 7.163 0 16 0h160c8.837 0 16 7.163 16 16v96c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V16z"
                fill="#fff"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M176 4H16C9.373 4 4 9.373 4 16v96c0 6.627 5.373 12 12 12h160c6.627 0 12-5.373 12-12V16c0-6.627-5.373-12-12-12zM16 0C7.163 0 0 7.163 0 16v96c0 8.837 7.163 16 16 16h160c8.837 0 16-7.163 16-16V16c0-8.837-7.163-16-16-16H16z"
                fill="#E8E8E7"
            />
            <path
                d="M86.074 67.333c.434 0 .833-.066 1.267-.2a2.495 2.495 0 001.069-.701c.3-.333.568-.733.767-1.267.2-.534.3-1.134.3-1.902 0-.667-.066-1.3-.2-1.834s-.368-1.035-.668-1.4a3.005 3.005 0 00-1.2-.902c-.502-.2-1.1-.3-1.835-.3H83.44v8.54h2.635v-.034zM113.161 59.627l1.701 4.971h-3.502l1.768-4.971h.033z"
                fill="#C06"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M77.602 94.455V37.812a4.279 4.279 0 014.27-4.27h20.382c22.381 0 32.09 13.278 32.09 30.389 0 17.88-9.709 30.524-32.09 30.524H77.602zm8.672-38.163c.867 0 1.668.134 2.435.4.767.267 1.401.7 1.968 1.235.534.567.967 1.267 1.301 2.068.3.833.468 1.801.468 2.935a10.02 10.02 0 01-.368 2.735c-.265.835-.633 1.568-1.132 2.168-.502.601-1.135 1.069-1.903 1.434-.767.334-1.668.534-2.701.534h-5.838V56.258h5.77v.034zm18.215 2.502h-7.14v2.903h6.572v2.302h-6.572v3.3h7.305v2.504H94.381V56.258h10.108v2.536zm15.276 11.041l-5.069-13.543h-3.103l-5.103 13.543h3.001l1.068-3.001h5.07l1.035 3.001h3.101zm4.838-13.543v11.041h6.606v2.501h-9.575V56.292h2.969z"
                fill="#C06"
            />
            <path
                d="M66.46 56.827a6.238 6.238 0 110 12.476 6.238 6.238 0 010-12.476zM61.724 85.015a9.432 9.432 0 009.44 9.44h.035v-16.81a4.735 4.735 0 00-4.738-4.738 4.733 4.733 0 00-4.737 4.737v7.371z"
                fill="#000"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M99.419 102.894h-39.83a6.405 6.405 0 01-6.404-6.404V31.543a6.406 6.406 0 016.404-6.405h39.83c37.795 0 43.433 24.318 43.433 38.796 0 25.12-15.444 38.961-43.433 38.961zm-39.83-75.622a4.258 4.258 0 00-4.27 4.27V96.49a4.258 4.258 0 004.27 4.271h39.83c26.619 0 41.297-13.077 41.297-36.828 0-31.89-25.886-36.66-41.297-36.66h-39.83z"
                fill="#000"
            />
        </g>
        <defs>
            <clipPath id="ideal-payment-rebranding_svg__clip0_101_983">
                <path fill="#fff" d="M0 0h192v128H0z" />
            </clipPath>
        </defs>
    </svg>
);

IdealPaymentRebrandingSvg.displayName = 'IdealPaymentRebrandingSvg';
export default IdealPaymentRebrandingSvg;
